import { Avatar, AvatarImage, AvatarFallback } from "@workspace/ui/components/ui/avatar";
import type { Review } from "@/lib/users-api";

type Person = Review["reviewer"];

export function ReviewPerson({ person, fallbackName, car }: {
  person: Person;
  fallbackName: string;
  car: Review["car"];
}) {
  const name = [person?.first_name, person?.last_name].filter(Boolean).join(" ").trim() || fallbackName;
  return (
    <>
      <Avatar className="h-10 w-10">
        {person?.profile_image && <AvatarImage src={person.profile_image} alt={name} />}
        <AvatarFallback className="bg-accent/10 text-xs">{name.charAt(0).toUpperCase()}</AvatarFallback>
      </Avatar>
      <div className="flex-1">
        <p className="text-sm font-semibold">{name}</p>
        {car && <p className="text-xs text-[#5a6b5a]">{car.year} {car.make} {car.model}</p>}
      </div>
    </>
  );
}